var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.6708 24.7484C25.4329 23.5859 25.7171 22.9918 26.2983 21.6872C22.01 20.0597 21.3254 13.9501 25.5621 11.6122C24.2704 9.98465 22.4492 9.04175 20.7312 9.04175C19.4912 9.04175 18.6387 9.36468 17.8767 9.66176C17.2308 9.90718 16.6496 10.1267 15.9262 10.1267C15.1512 10.1267 14.4667 9.88135 13.7433 9.62301C12.9554 9.33885 12.1287 9.04175 11.0954 9.04175C9.17082 9.04175 7.11708 10.2172 5.81249 12.2322C3.97833 15.0738 4.30125 20.3955 7.25916 24.9422C8.31833 26.5697 9.73916 28.3909 11.5862 28.4167C12.3612 28.4297 12.865 28.1972 13.4204 27.9518C14.0533 27.6676 14.7379 27.3576 15.9392 27.3576C17.1404 27.3447 17.8121 27.6676 18.445 27.9518C18.9875 28.1972 19.4783 28.4297 20.2404 28.4167C22.1133 28.3909 23.6117 26.3759 24.6708 24.7484Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.46 2.58325C20.6667 4.00409 20.0854 5.41202 19.3233 6.39368C18.5096 7.45285 17.0888 8.2795 15.7196 8.22783C15.4742 6.85866 16.1071 5.45074 16.8821 4.50782C17.7475 3.47449 19.2071 2.67367 20.46 2.58325Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.946a3c269c91649fe98bdc9669f05b6a.svg";
export { ForwardRef as ReactComponent };